var map = {
	"./agpay/icon_account_default.png": "48c0",
	"./aipay/icon_account_default.png": "f2ea",
	"./anpay/icon_account_default.png": "0ede",
	"./qpay/icon_account_default.png": "3b0c",
	"./qtpay/icon_account_default.png": "13c8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "98a0";